import { patch } from "../../../configs/api";

export async function patchCompleteProfileQueryFn(data) {

    const { id, ...rest } = data;

    return await patch(`/users/${id}/complete-profile`, rest);
}